import React from 'react';

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m8 2.06-1.407 3.587c-.13.33-.432.558-.783.59l-3.77.35 2.905 2.645c.252.23.36.578.282.91l-.889 3.8 3.163-2.047c.3-.195.686-.2.992-.012l3.392 2.08-.434-1.684c-.068-.263.09-.53.351-.599.262-.068.528.09.596.353l.461 1.79c.21.817-.674 1.476-1.39 1.037l-3.462-2.124-3.232 2.092c-.706.458-1.606-.181-1.414-1.003l.908-3.882-2.961-2.697c-.602-.548-.268-1.554.541-1.629l3.844-.356 1.438-3.667c.311-.792 1.427-.792 1.738 0l1.438 3.667 3.844.356c.809.075 1.143 1.08.541 1.63l-3.175 2.89c-.2.183-.51.167-.69-.034-.182-.2-.167-.512.033-.694l3.1-2.823-3.77-.348c-.351-.033-.654-.261-.783-.59z",
    clipRule: "evenodd"
  }));
};
SvgStar.displayName = "Star";

export { SvgStar as S };
